// removed by extract-text-webpack-plugin
module.exports = {"formula":"_2Hhl3 _2zlem Wr_al _1ocN4","formulaHeader":"_3CI1f _38618 _3Dqep _20SLo _2XN97 _1aL0S","formulaTitle":"kp0FY _1Wqf2","formulaDefinitionInner":"_1kWrk _2z9kb"};


//////////////////
// WEBPACK FOOTER
// ./reference/components/Formula.css
// module id = 2235
// module chunks = 3